import { IconArrowLeft } from "@tabler/icons-react";
import { Link, NavLink, Outlet } from "react-router-dom";

import { GUIDE, GUIDE_GROUPS } from "../../content/guide";
import { ThemeSwitch } from "../layout/ThemeSwitch";

/**
 * The guide's own frame: a documentation space, not a console screen.
 *
 * Behind the same sign-in as everything else — it renders inside the session
 * gate — but outside the console shell: reading deserves its own room, and a
 * manual squeezed beside the fleet was one screen pretending to be twelve.
 * The header keeps the two ways out (the console, the theme); the left rail
 * is the guide's own table of contents, grouped the way the work is grouped.
 *
 * Returns:
 *     The documentation frame around the current section.
 */
export function DocsLayout(): JSX.Element {
  return (
    <div className="docs">
      <header className="docs__header">
        <Link to="/docs" className="docs__brand">
          <img
            className="docs__logo"
            src="/brand/logomark-white.svg"
            width={36}
            height={20}
            alt="Neuralk"
          />
          <span className="docs__brand-text">
            <span className="docs__brand-name">Guide</span>
            <span className="docs__brand-org">GPU Console</span>
          </span>
        </Link>
        <div className="docs__header-actions">
          <ThemeSwitch />
          <Link to="/" className="docs__back">
            <IconArrowLeft size={14} aria-hidden="true" />
            Back to the console
          </Link>
        </div>
      </header>

      <div className="docs__body">
        <nav className="docs__nav" aria-label="Guide sections">
          {GUIDE_GROUPS.map((group) => (
            <div key={group} className="docs__nav-group">
              <span className="eyebrow docs__nav-title">{group}</span>
              {GUIDE.filter((section) => section.group === group).map(
                (section) => (
                  <NavLink
                    key={section.id}
                    to={`/docs/${section.id}`}
                    className={({ isActive }) =>
                      `docs__nav-link${isActive ? " docs__nav-link--active" : ""}`
                    }
                  >
                    {section.title}
                  </NavLink>
                ),
              )}
            </div>
          ))}
        </nav>

        <main className="docs__main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
